import {SignalStoreNames} from '@shared-types';
import {livenessValidatorInitialState} from '@validations/data-access';

import {IAppSyncSignalStoresSchema} from '../types';

export const signalStoresInitialState: IAppSyncSignalStoresSchema = {
	[SignalStoreNames.LIVENESS_VALIDATOR]: livenessValidatorInitialState,
};
